/* TransformHQ Exercise Library — no player requests before an explicit click. */
(() => {
  if (window.THQExerciseLibrary) { window.THQExerciseLibrary.refresh(); return; }
  const instances = new Map();
  const clean = value => String(value || '').trim();
  const normal = value => clean(value).toLocaleLowerCase();
  function safeURL(value, video = false) {
    try {
      const u = new URL(value, location.origin);
      if (u.protocol !== 'https:') return '';
      if (video && (u.hostname !== 'iframe.mediadelivery.net' || !/^\/embed\/\d+\/[a-f\d-]+$/i.test(u.pathname))) return '';
      return u.href;
    } catch { return ''; }
  }
  function init(root) {
    const q = selector => root.querySelector(selector);
    const config = JSON.parse(q('[data-config]').textContent);
    const grid = q('[data-grid]'), search = q('[data-search]'), category = q('[data-categories]');
    const equipment = q('[data-equipment]'), more = q('[data-more]'), count = q('[data-count]');
    const dialog = q('dialog'), stage = q('[data-stage]');
    const controller = new AbortController(), signal = controller.signal;
    let catalog = [], activeCategory = '', limit = Number(config.batch) || 12, trigger = null;
    const on = (el, event, fn) => el.addEventListener(event, fn, {signal});
    function label(tag, text, className) { const el = document.createElement(tag); el.textContent = text; if(className) el.className = className; return el; }
    function close() { stage.replaceChildren(); if(dialog.open) dialog.close(); if(trigger?.isConnected) trigger.focus(); }
    function open(item, button) {
      trigger = button; q('[data-modal-title]').textContent = item.title;
      q('[data-modal-description]').textContent = item.description || '';
      const url = new URL(safeURL(item.url, true));
      url.searchParams.set('autoplay', 'false'); url.searchParams.set('preload', 'false'); url.searchParams.set('responsive', 'true');
      const frame = document.createElement('iframe'); frame.src = url.href;
      frame.title = item.title; frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; frame.allowFullscreen = true;
      stage.replaceChildren(frame); dialog.showModal(); q('[data-close]').focus();
    }
    function card(item) {
      const article = label('article', '', 'thq-card');
      const button = label('button', '', 'thq-card__watch'); button.type = 'button'; button.setAttribute('aria-label', `${config.watchLabel}: ${item.title}`);
      const media = label('span', '', 'thq-card__media');
      const fallback = label('span', item.category, 'thq-card__fallback'); media.append(fallback);
      const src = safeURL(item.thumbnail);
      if(src) { const image = document.createElement('img'); image.src = src; image.alt = ''; image.loading = 'lazy'; image.decoding = 'async'; image.width = 640; image.height = 360; image.addEventListener('error', () => image.remove(), {once:true}); media.append(image); }
      const play = label('span', '▶', 'thq-card__play'); play.setAttribute('aria-hidden','true'); media.append(play);
      const copy = label('span', '', 'thq-card__copy'); copy.append(label('span', item.title, 'thq-card__title'));
      if(config.showCategory) copy.append(label('span', item.category, 'thq-card__meta'));
      if(item.equipment) copy.append(label('span', item.equipment, 'thq-card__equipment'));
      button.append(media, copy); on(button, 'click', () => open(item,button)); article.append(button); return article;
    }
    function render() {
      const term = normal(search.value), selectedEquipment = equipment.value;
      const result = catalog.filter(item => (!activeCategory || item.category === activeCategory) && (!selectedEquipment || item.equipment === selectedEquipment) && normal([item.title,item.category,item.equipment,item.description].join(' ')).includes(term));
      grid.replaceChildren(...result.slice(0,limit).map(card));
      count.textContent = `${Math.min(limit,result.length)} ${config.ofLabel} ${result.length} ${config.resultsLabel}`;
      more.hidden = limit >= result.length; q('[data-empty]').hidden = result.length > 0;
      q('[data-reset]').hidden = !term && !activeCategory && !selectedEquipment;
      category.querySelectorAll('button').forEach(b => {b.setAttribute('aria-pressed', String(b.dataset.category === activeCategory));});
    }
    function read() {
      const oldEquipment = equipment.value;
      const sources = document.querySelectorAll('[data-thq-catalog]');
      catalog = [];
      for(const source of sources) {
        try { const data=JSON.parse(source.textContent); if(Array.isArray(data)) catalog.push(...data); } catch (e) { console.error('Invalid exercise catalog',e); }
      }
      catalog = catalog.filter(x=>x.enabled !== false && clean(x.title) && safeURL(x.url,true)).map(x=>({...x,title:clean(x.title),category:clean(x.category)||config.otherLabel,equipment:clean(x.equipment)}));
      const cats = [...new Set(catalog.map(x=>x.category))];
      if(!cats.includes(activeCategory)) activeCategory='';
      category.replaceChildren();
      for(const name of ['',...cats]) { const b=label('button',name||config.allLabel); b.type='button'; b.dataset.category=name; b.setAttribute('aria-pressed',String(name===activeCategory)); on(b,'click',()=>{ activeCategory=name;limit=Number(config.batch)||12;render(); }); category.append(b); }
      equipment.replaceChildren(new Option(config.equipmentLabel,''));
      for(const name of [...new Set(catalog.map(x=>x.equipment).filter(Boolean))].sort()) equipment.add(new Option(name,name));
      equipment.value=[...equipment.options].some(o=>o.value===oldEquipment)?oldEquipment:'';
      equipment.closest('[data-equipment-wrap]').hidden = !config.showEquipment || equipment.options.length < 2;
      render();
    }
    on(search,'input',()=>{limit=Number(config.batch)||12;render();});
    on(equipment,'change',()=>{limit=Number(config.batch)||12;render();});
    on(more,'click',()=>{const before=grid.children.length;limit+=Number(config.batch)||12;render();grid.children[before]?.querySelector('button')?.focus();});
    on(q('[data-reset]'),'click',()=>{search.value='';equipment.value='';activeCategory='';limit=Number(config.batch)||12;render();search.focus();});
    on(q('[data-close]'),'click',close);
    on(dialog,'cancel',event=>{event.preventDefault();close();});
    on(dialog,'close',()=>stage.replaceChildren());
    on(dialog,'click',event=>{ if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();} });
    instances.set(root,{read,destroy(){close();controller.abort();}});read();
  }
  function refresh() {
    for(const [root,instance] of instances) if(!root.isConnected){instance.destroy();instances.delete(root);}
    document.querySelectorAll('[data-thq-library]').forEach(root=>{if(!instances.has(root))init(root);else instances.get(root).read();});
  }
  window.THQExerciseLibrary={refresh};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
  document.addEventListener('shopify:section:load',refresh);
  document.addEventListener('shopify:section:unload',()=>setTimeout(refresh,0));
  document.addEventListener('shopify:section:reorder',refresh);
})();
